<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-11 17:02:40
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-08-24 16:49:05
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/component/orderInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
  <div>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">订单状态:</span>
        <span class="e-descriptions-item-content" v-if="flag">{{
          getApplyStatusType(applyInfo.agencyApplyStatus)
        }}</span>
        <span
          class="e-descriptions-item-content"
          v-else
          :class="{
            'color-red':
              applyStatus === 219 || applyStatus === 213 || applyStatus === 212
          }"
          >{{ applyInfo.applyStatusString }}</span
        >
        <span
          v-if="applyStatus === 219"
          class="e-descriptions-item-content color-red"
          >, 您的申请于
          {{ applyInfo.refuseApplyOperationLogVO.approvalTime }} 审核驳回</span
        >
      </el-col>
      <el-col :span="12">
        <span class="e-descriptions-item-label">现场审查费:</span>
        <span class="e-descriptions-item-content"
          >￥{{ applyInfo.siteReviewFee | thousandsSeparator }}
          <i class="e-descriptions-item-remark"
            >(首次申请时收取，三年内无需再次支付)</i
          ></span
        >
      </el-col>
    </el-row>
    <el-row v-if="applyStatus === 219" style="margin-top: -14px">
      <el-col :span="12">
        <span class="e-descriptions-item-label"></span>
        <div class="e-descriptions-item-content color-red">
          驳回原因：
          <e-tooltip
            :content="applyInfo.refuseApplyOperationLogVO.reason"
            :set-length="18"
            style="display: inline-block"
          />
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">申请单号:</span>
        <span class="e-descriptions-item-content">{{
          applyInfo.applyCode
        }}</span>
      </el-col>
      <el-col :span="12">
        <span class="e-descriptions-item-label">产品检测费:</span>
        <span class="e-descriptions-item-content"
          >￥{{ applyInfo.amount | thousandsSeparator }}</span
        >
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">申请日期:</span>
        <span class="e-descriptions-item-content">{{
          applyInfo.applyTime
        }}</span>
      </el-col>
      <el-col :span="12">
        <span class="e-descriptions-item-label">总评价费:</span>
        <span class="e-descriptions-item-content color-red"
          >￥{{ applyInfo.totalAmount | thousandsSeparator }}</span
        >
      </el-col>
    </el-row>
    <div
      class="pay-wrap"
      v-if="isHasOperation && [208, 209, 210].includes(applyStatus)"
    >
      <span class="txt"
        >请于90天内完成评价费支付，否则系统将自动关闭您的申清</span
      >
      <eui-btn
        type="primary"
        v-if="
          applyInfo.isOnlinePay && (applyStatus === 208 || applyStatus === 210)
        "
        @click="toPay"
        >去支付</eui-btn
      >
      <eui-btn type="primary" v-else @click="openingAccount">开通账户</eui-btn>
    </div>
  </div>
</template>

<script>
import { listTypeInfo } from '../../applyConfirm/components/componentsData';
import { easySeries } from '../../../../api/config';
import eTooltip from '../../../../components/common/e-tooltip';
export default {
  props: {
    applyInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    flag: {
      type: String,
      default: ''
    },
    isHasOperation: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      listTypeInfo,
      applyStatus: 0
    };
  },

  components: { eTooltip },

  computed: {},

  created() {
    this.applyStatus = Number(this.$route.query.applyStatus);
  },
  methods: {
    openingAccount() {
      this.$router.push({
        path: '/paymentAccount'
      })
    },
    toPay() {
      let params = {
        applyId:this.applyInfo.applyId,
        companyName:this.applyInfo.companyName,
        totalAmount:this.applyInfo.amount
      };
      this.$router.push({ path: '/ES/ESapply/ESorganizationPayment' ,query:params});
    },
    getApplyStatusType(applyStatusType) {
      const { applyStatusList } = this.listTypeInfo;
      const { name } =
        applyStatusList.find(item => {
          return item.id === applyStatusType;
        }) || {};
      return name;
    }
  }
};
</script>
<style lang="scss" scoped>
.e-descriptions-item-label,
.e-descriptions-item-content {
  font-size: 14px;
  color: #333;
  line-height: 1;
  &.color-red {
    color: #e50113;
  }
  i {
    color: #999;
    font-size: 12px;
  }
}
.e-descriptions-item-label {
  display: inline-block;
  width: 80px;
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0;
}
.el-row {
  line-height: 1;
}
.el-row:not(:last-child) {
  margin-bottom: 20px;
}
.el-col {
  display: flex;
}
.pay-wrap {
  text-align: right;
  padding-top: 20px;
  border-top: 1px dotted #c5c5c5;
  .txt {
    font-size: 14px;
    color: #333;
    margin-right: 20px;
  }
}
</style>
